import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomepageService } from '../../shared/services/homepage/homepage.service';
import { PressClubItemComponent } from '../press-club-item/press-club-item.component';
import { ButtonModule } from '../button/button.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UtilService } from 'src/app/shared/services';
import { map } from 'rxjs';

@Component({
  selector: 'app-press-club',
  standalone: true,
  imports: [
    CommonModule,
    PressClubItemComponent,
    ButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './press-club.component.html',
  styleUrls: ['./press-club.component.scss']
})
export class PressClubComponent {
  constructor(
    private homepageService: HomepageService,
    private util: UtilService
  ) {}
  pressClubList = [];
  currentPage = 1;
  isLoading = false;
  lastPage = 1;
 
  ngOnInit() {
   this.getPressClubData('init'); 
  }

  getPressClubData(choice?) {
    if (choice === 'prev') {
      if (this.currentPage !== 1) {
        this.currentPage -= 1;
      }
    } else if (choice === 'next') {
      if (this.currentPage !== this.lastPage) {
        this.currentPage += 1;
      }
    } else if (choice === 'init') {
      this.currentPage = 1;
    } else if (choice === 'last') {
      this.currentPage = this.lastPage;
    }
    this.isLoading = true;
    this.homepageService.getPressClubData(this.currentPage)
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.lastPage = res.data.last_page;
          this.pressClubList = res.data.data;
          this.scrollUp();
        },
        error: (error: any) => {
          this.isLoading = false;
        }
      })
  }

  scrollUp(): void {
    this.util.scrollIntoViewSmoothlyByClass('main-wrapper');
  }

  onPaginationHandler(item: any) {
    if (item.label.includes('previous')|| +item.label < this.currentPage) {
      this.getPressClubData('prev');
    }
    else if (item.label.includes('next') || +item.label > this.currentPage) {
      this.getPressClubData('next');
    }
  }
}
